module.exports = __webpack_public_path__ + "img/mail.f30ec77.svg";